export const platformConfig = {
  apiUrl: "https://api.nei.org/api/v1",
  production: true
};

export const productionHosts = [
  "neichurch.org",
  "www.neichurch.org",
  "api.neichurch.org",
];